import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import CopyrightFooter from './CopyrightFooter';

const Footer = ({ showCTA = true }) => {
  return (
    <>
      {/* CTA Section */}
      {showCTA && (
        <section className="footer-cta-section">
          <div className="footer-cta-content">
            <h2 className="footer-cta-title">Ready to Get Started?</h2>
            <p className="footer-cta-subtitle">
              Join developers optimizing their embedded systems with automated memory analysis
            </p>
            <Link className="footer-cta-button" to="/signup">Start Free Today</Link>
          </div>
        </section>
      )}

      {/* Copyright Footer */}
      <CopyrightFooter />
    </>
  );
};

export default Footer;
